import { useMemo } from 'react';
import { useWorkouts } from './useWorkouts';
import { useWater } from './useWater';
import { useCalories } from './useCalories';
import { useSleep } from './useSleep';
import { useHabits } from './useHabits';
import { localDateKey } from '../utils/dateKey';

const SLEEP_GOAL_HOURS = 8;

function pct(value, goal) {
  if (!goal || goal <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((value / goal) * 100)));
}

/**
 * LifeScore is a plain average of 5 equal-weighted categories, each capped at
 * 100%. It's a deterministic formula, not an AI-generated insight.
 */
export function useLifeScore() {
  const { workouts } = useWorkouts();
  const water = useWater();
  const calories = useCalories();
  const { todayEntry: sleepToday } = useSleep();
  const { todayCompletionPct, habits } = useHabits();

  const today = localDateKey();

  const workoutPct = useMemo(
    () => (workouts.some((w) => (w.date || '').slice(0, 10) === today) ? 100 : 0),
    [workouts, today]
  );

  const waterPct = pct(water.amountMl, water.goalMl);
  const caloriesPct = pct(calories.totalCalories, calories.goal);
  const sleepPct = pct(sleepToday?.hours || 0, SLEEP_GOAL_HOURS);
  const habitsPct = habits.length ? todayCompletionPct : 0;

  const breakdown = { workout: workoutPct, water: waterPct, calories: caloriesPct, sleep: sleepPct, habits: habitsPct };
  const overall = Math.round(
    (workoutPct + waterPct + caloriesPct + sleepPct + habitsPct) / 5
  );

  return { overall, breakdown };
}
